import RamzovaPage from "../../../components/customOrgs/senzacni/RamzovaPage";

export default function Ramzova() {
    return <RamzovaPage />;
}
